// Application Configurations
import businessWelcome from '../../Features/Business/businessConfiguration';
import leasing from '../../Features/Leasing/leasingConfiguration';

const tenantApplications = [businessWelcome, leasing];

export default tenantApplications;
